(function() { module.exports = window["Next"]["Search"]; }());